
const digest = 'b9d0503107ef95d0e676091091bd2535c4a5b3d5501f383b8ff7c3f5ddc043ae';
const classes = {"item":"_item_fj1z3_1","selected":"_selected_fj1z3_21","hidden":"_hidden_fj1z3_26"};
const css = `._item_fj1z3_1 {
  flex-basis: 20%;
  height: 60px;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: normal;
  font-weight: 600;
  color: #33a5de;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  transition-property: color, background-color, box-shadow;
  padding: 0 16px;
  cursor: pointer;
  box-shadow: 0 0 0 1px #e6e7eb;
  box-sizing: border-box;
}

._selected_fj1z3_21 {
  color: #fff;
  background-color: #7a8599;
}

._hidden_fj1z3_26 {
  color: #e6e7eb;
  pointer-events: none;
  cursor: default;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  